var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found",style:('width: ' + _vm.width + 'px;margin:auto;padding:20px 0;opacity:0.7;')},[_c('no-data'),_c('h2',{staticStyle:{"text-align":"center","color":"#555"}},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticStyle:{"text-align":"center","color":"#666"}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }